<template>
  <div class="nonPhysical-page">
    <el-tabs v-model="goodsTypeTab" @tab-click="goodsTypeTabHandleClick">
      <el-tab-pane label="当期网络零售额" name="currentSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-col :span="3">
              <el-select v-model="value" placeholder="请选择"  size="small" @change="getWholeList" class="margin-l-20">
                <el-option v-for = 'item in typeList'  :key="item.value" :label="item.value" :value="item.value"></el-option>
              </el-select>
            </el-col>
            <el-form-item label="时间：" style="margin-left: 200px">
              <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" :picker-options="pickerOptions"
                              size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM"
                              value-format="yyyy-MM" :clearable="false"></el-date-picker>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="oneTierOptions" autoresize class="width-z100"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="oneTierTable" height="430" stripe class="float-left border-DEDEDE margin-t-10"
                        :default-sort="{prop: 'absoulte_value', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="行业" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" width="190" align="center"></el-table-column>
<!--                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>-->
              </el-table>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="累计网络零售额" name="cumulativeSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-col :span="3">
              <el-select v-model="value" placeholder="请选择"  size="small" @change="getWholeList" class="margin-l-20">
                <el-option v-for = 'item in typeList'  :key="item.value" :label="item.value" :value="item.value"></el-option>
              </el-select>
            </el-col>
            <el-form-item label="时间：" style="margin-left: 200px">
              <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" :picker-options="pickerOptions"
                              size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM"
                              value-format="yyyy-MM" :clearable="false"></el-date-picker>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
                <chart ref="chart1" :options="oneTierOptions" autoresize class="width-z100"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
                <el-table :data="oneTierTable" stripe height="430" class="float-left border-DEDEDE margin-t-10"
                          :default-sort="{prop: 'absoulte_value', order: 'descending'}">
                  <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
                  <el-table-column prop="absoulte_key" label="行业" align="center"></el-table-column>
                  <el-table-column prop="absoulte_value" label="网络零售额（万元）" width="190" align="center"></el-table-column>
<!--                  <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>-->
                </el-table>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">
      注：<br/>
      1.根据国家统计局定义，商品和服务包括实物商品和非实物商品（如虚拟商品、服务类商品）；<br/>
      2.服务类商品划分为餐饮服务、住宿服务、旅游服务、通信服务、教育服务、文化和体育及娱乐服务、居民生活服务、交通仓储邮政服务、非金融机构支付服务、咨询服务、广告会展服务、其他服务，共12个大类。<br/>
      3.虚拟商品包括充值缴费、IP卡/网络电话/手机号码、电子消费卡券、游戏/点卡/账号/道具/代练、其他虚拟商品。
    </p>
  </div>
</template>

<script>
    export default {
        name: "nonPhysical",
      data () {
        return {
          goodsTypeTab: 'currentSales',
          chooseType: '当期网络零售额',//当前选择查询条件
          value:"九江市",
          typeList:[{'value':'九江市'},{'value':'柴桑区'},{'value':'德安县'},{'value':'都昌县'},{'value':'共青城市'},
            {'value':'湖口县'},{'value':'濂溪区'},{'value':'庐山市'},{'value':'彭泽县'},{'value':'瑞昌市'},{'value':'武宁县'},
            {'value':'修水县'},{'value':'浔阳区'},{'value':'永修县'}],
          oneTierOptions: {}, //非实物行业网络零售额图表
          oneTierTable: [],//非实物行业表格
          currentSalesForm: {startTime: '', endTime: ''},//当期网络零售额筛选条件
          wholeTime: '1',
          cumulativeSalesOptions: {},//累计网络零售额图表
          currentRetailOptions: {},//当期网络零售量图表
          cumulativeRetailOptions: {},//累计网络零售量图表
          peopleEngagedNumOptions: {},//从业人数图表
          ExpressDeliveryVolumeOptions: {},//快递量图表

          cityChoose: [{
            id: 1,
            name: '南昌市',
            children: [{id: 1, name: '青山湖区'}, {id: 2, name: '东湖区'}, {id: 3, name: '西湖区'}, {id: 4, name: '南昌县'}, {
              id: 5,
              name: '青云谱区'
            }, {id: 6, name: '新建区'}, {id: 7, name: '进贤县'}, {id: 8, name: '湾里区'}, {id: 9, name: '安义县'}]
          },
            {id: 2, name: '九江'}, {id: 3, name: '景德镇'}, {id: 4, name: '上饶'},
            {id: 5, name: '鹰潭', children: [{id: 1, name: '贵溪市'}]}, {id: 6, name: '宜春'}, {id: 7, name: '萍乡'}, {
              id: 8,
              name: '新余'
            }, {id: 9, name: '抚州'}, {id: 10, name: '吉安'}, {id: 11, name: '赣州'}],
          productTime: '1',
          productForm: {way: '1', endTime: ''}, //商品大类筛选条件
          transactionTime: '1',
          transactionTitle: '',
          transactionForm: {way: '1', resource: '1', startTime: '', endTime: '', platform: '全部'},//交易平台筛选条件
          regionDis: true,
          //表格数据

          productTwoTable: [],
          forecastOptions:{},//行业预测
          featuredIndustryOptions:{},//特色行业
          pickerOptions: {
            disabledDate: (time) => {
              // console.log(time.getMonth());
              let nowDate = new Date()
              let day = nowDate.getDate()
              nowDate.setDate(1);
              if (day > 14) {
                if(nowDate.getMonth()==0){
                  nowDate.setMonth(11);
                  nowDate.setFullYear(nowDate.getFullYear()-1);
                }
                else{
                  nowDate.setMonth(nowDate.getMonth()-1);
                }
              } else {
                if(nowDate.getMonth()==0){
                  nowDate.setMonth(10);
                  nowDate.setFullYear(nowDate.getFullYear()-1);
                }
                else if(nowDate.getMonth()==1){
                  nowDate.setMonth(11);
                  nowDate.setFullYear(nowDate.getFullYear()-1);
                }
                else{
                  nowDate.setMonth(nowDate.getMonth()-2);
                }
              }
              if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
            }
          },
        }
      },
      mounted () {

      },
      created () {
        this.$emit('public_header', true)
        this.oneMonth()
        // this.oneMonth()
      },
      methods: {
        dateChangebirthday (val) {
          this.wholeTime = 2
          this.currentSalesForm.value1 = val
        },
        goodsTypeTabHandleClick (tab, event) {
          if (tab.name == 'cumulativeSales') {
            this.chooseType = '累计网络零售额'
            this.getWholeList()
          }
          if (tab.name == 'currentSales') {
            this.chooseType = '当期网络零售额'
            this.getWholeList()
          }

        },
        //行业列表
        getWholeList () {
          this.$http.get(this.header + '/qyjc/nonGoodsIndustry', {
            params: {
              index_type: this.chooseType,
              times: this.currentSalesForm.endTime,
              city: this.value,
            }
          }).then(res => {
            if (res.data.code == 0) {

              let wholeList = {xName: [], yTotalMoney: []}
              //非实物行业图表
              res.data.nonGoodsIndustry.forEach((y, index) => {
                wholeList.xName.push(y.absoulte_key)
                let yMoney = {
                  value: y.absoulte_value,
                  unit: '万元'
                }
                if(y.absoulte_value_yoy == null){
                  y.absoulte_value_yoy = '--'
                }
                wholeList.yTotalMoney.push(yMoney)
              })
              this.oneTierTable = res.data.nonGoodsIndustry.reverse()
              let Min1 = this.calMin(wholeList.yTotalMoney), Max1 = this.calMax(wholeList.yTotalMoney)
              //行业图表

              this.oneTierOptions = {
                title: {//图表标题
                  text: this.value + '非实物行业'+this.chooseType,
                  left: 'left',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300,
                    marginBottom: 1000
                  },
                },
                grid: {
                  left: '6%',
                  // right: '4%',
                  top:'15%',
                  bottom: '3%',
                  containLabel: true
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  formatter: '{b}网络零售额<br/>{c} 万元'
                },
                toolbox: { //图表工具箱
                  feature: {
                    // dataView: {show: true, readOnly: false},
                    magicType: {show: true, type: ['line', 'bar']},
                    // restore: {show: true},
                    saveAsImage: {show: true}
                  }
                },
                yAxis: {
                  type: 'value',
                  name: '万元',
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  min: 0,
                  // max: Max1,
                  // splitNumber: 5,
                  // interval: (Max1 - 0) / 5,
                },
                xAxis: {
                  type: 'category',
                  // axisLabel: {'interval': 0, rotate: 40},
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  data: wholeList.xName
                },
                series: [{
                  name: '月份',
                  type: 'bar',
                  barCategoryGap: '60%',
                  itemStyle: {
                    normal: {
                      color: function (params) {
                        var colorList = ['#4c83d2', '#7ba9eb', '#68b0dc', '#8a98e8']
                        //  var colorList = ['red','blue'];
                        return colorList[params.dataIndex % 4]
                      }
                    },
                    emphasis: {
                      color: '#83bff6'
                    }
                  },
                  data: wholeList.yTotalMoney,
                }]
              }
            } else {
              this.$alert(res.data.msg)
            }

          })
        },
        //选择近1个月
        oneMonth (val) {
          let dataArr = []
          let data = new Date()
          let day = data.getDate()
          data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
          for (var i = 0; i < 3; i++) {
            data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
            var m = data.getMonth() + 1
            m = m < 10 ? '0' + m : m
            dataArr.push(data.getFullYear() + '-' + (m))
          }
          if (day > 14) {
            this.currentSalesForm.endTime = dataArr[1]
          } else {
            this.currentSalesForm.endTime = dataArr[2]
          }
          this.wholeTime = '1'
          this.getWholeList()

        },
        //计算最大值
        calMax (arr) {
          let max = 0
          // arr.forEach((el) => {
          arr.forEach((el1) => {
            if (!(el1 === undefined || el1 === '')) {
              if (max < el1.value) {
                max = el1.value
              }
            }
            // })
          })
          let maxInt = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
          let maxVal = maxInt * 10//让显示的刻度是整数
          return maxVal
        },

        //计算最小值
        calMin (arr) {
          let min = 0
          // arr.forEach((el) => {
          arr.forEach((el1) => {
            if (!(el1 === undefined || el1 === '')) {
              if (min > el1.value) {
                min = el1.value
              }
            }
          })
          // })
          let minInt = Math.floor(min / 10)
          let minVal = minInt * 10//让显示的刻度是整数
          return minVal
        },
      }
    }
</script>

<style>
  .nonPhysical-page {}

  .nonPhysical-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
    /*color: #CED4DF;*/
  }

  .nonPhysical-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .nonPhysical-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .nonPhysical-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .nonPhysical-page .el-form-item {
    margin-bottom: 0;
  }

  .nonPhysical-page .el-radio, .nonPhysical-page .el-form-item__label {
    color: #666;
  }
  .nonPhysical-page .el-select .el-input__inner{
    width: 170px;
    height: 32px;
    color: #6B7991 !important;
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/area/nonPhysical.vue